import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { trackCatalogSearchFromPath, trackPageView } from "@/lib/analytics";
export function AnalyticsBeacon() {
  const $ = _c(3);
  const router = useRouter();
  const asPath = router.asPath || "/";
  let t0;
  let t1;
  if ($[0] !== asPath) {
    t0 = () => {
      if (asPath.startsWith("/admin")) {
        return;
      }
      trackPageView(asPath);
      trackCatalogSearchFromPath(asPath);
    };
    t1 = [asPath];
    $[0] = asPath;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}